import type { SitesSchedule } from "@ihr-radioedit/inferno-webapi";

export function isScheduled(now: number, schedule?: Pick<SitesSchedule, "begin" | "end"> | null) {
  if (!schedule) {
    return true;
  }
  const begin = schedule.begin || now;
  const end = schedule.end || Number.MAX_SAFE_INTEGER;
  return begin <= now && end > now;
}
